import {
    SOLICITO_INFORMACION_TURNOS,
    SOLICITO_INFORMACION_TURNOS_EXITO,
    SOLICITO_INFORMACION_TURNOS_ERROR
} from '../types';

import clienteAxios from '../config/axios';

export function cargarTurnosAction(informacion) {
    return async (dispatch) => {
        dispatch(cargarTurnos());

        try {
            const { config } = informacion;

            const { data } = await clienteAxios.get(
                '/paciente/cargarturnos',
                config
            );

            const dataNormalizada = {
                ...data,
                info_calendario: data.turnos || []
            };

            dispatch(cargarTurnosExito(dataNormalizada));

            return dataNormalizada;

        } catch (error) {
            const mensajeError =
                error.response?.data ||
                error.message ||
                'No se pudieron cargar los turnos';

            dispatch(cargarTurnosError(mensajeError));

            throw error;
        }
    };
}

const cargarTurnos = () => ({
    type: SOLICITO_INFORMACION_TURNOS,
    payload: true
});

const cargarTurnosExito = (data) => ({
    type: SOLICITO_INFORMACION_TURNOS_EXITO,
    payload: data
});

const cargarTurnosError = (msg) => ({
    type: SOLICITO_INFORMACION_TURNOS_ERROR,
    payload: msg
});